const USER_ROLES = {
  Administrador: "Administrador",
  Leitor: "Leitor",
}

export default USER_ROLES